// Mirror of backend MAJOR_OOS_ITEMS_BACKEND from server.py — used to color
// FAIL items in the View page. Keep both lists in sync; if backend changes,
// update this file too.
const MAJOR_OOS_ITEMS = new Set([
  "Steps, grab handles, ladders secure & clean",
  "Air filter / pre-cleaner condition",
  "ROPS / FOPS structure - no cracks or damage",
  "Seat & seat belt - functional, not torn",
  "Horn operational",
  "Backup alarm operational",
  "Service brakes - firm pedal, holds machine",
  "Parking brake - holds machine on grade",
  "Steering - responsive, no excessive play",
  "Emergency / kill switch operational",
  "Visible fluid leaks (engine, hydraulic, fuel, coolant)",
  "Belts and hoses - no cracks, fraying, or leaks",
  "Tires - inflation, cuts, sidewall damage, tread wear",
  "Tires - inflation, cuts, tread wear",
  "Tires - inflation, condition, no cuts (front & rear)",
  "Tires - inflation, cuts, tread",
  "Tires - inflation, cuts, tread depth (all positions)",
  "Tires - inflation, cuts, tread (front & rear)",
  "Tires (rear, if smooth-drum) - inflation, wear",
  "Tires / tracks - condition & wear",
  "Tracks or tires - condition & wear",
  "Tracks / undercarriage - tension, wear, no missing pads",
  "Tracks / undercarriage - tension, wear",
  "Tracks / undercarriage - tension & wear",
  "Tracks / undercarriage - condition & wear",
  "Tracks - tension, drive sprockets, idlers",
  "Strobe / beacon light (Required)",
  "Fire extinguisher present, charged & inspected",
  "Hydraulic hoses - no chafing or bulges",
  "Hydraulic cylinders - rod condition, no leaks",
  "Hydraulic cylinders & hoses",
  "Hydraulic couplers / auxiliary lines - no leaks",
  "Hydraulic hoses & cylinders",
  "Boom, stick, bucket - no cracks at pivot points",
  "Backhoe boom, dipper, bucket - no cracks at pivots",
  "Lift arms & linkage - no cracks",
  "Lift arms - no cracks, pivot pins secure",
  "Loader arms, pins, retainers secure",
  "Tow arms / tow points - no cracks",
  "Boom sections - no cracks, wear pads in place",
  "Stabilizer pads / outriggers - operate, no leaks",
  "Stabilizer / outrigger controls",
  "Stabilizer / outrigger pads (if equipped) operate freely",
  "Stabilizer / frame-level controls",
]);

export const itemSeverity = (itemName) =>
  MAJOR_OOS_ITEMS.has(itemName) ? "oos" : "attn";
